import { Identifier } from "../models";

export const InsertOrRemoveIdentifier = (stateValues: Identifier[] | undefined, identifier: Identifier) => {
  const currentValues = [...(stateValues ?? [])];
  const existingIndex = currentValues.find((cv) => cv.id === identifier.id);
  if (existingIndex) return currentValues.filter((cv: Identifier) => cv.id !== identifier.id);
  else return [...currentValues, { id: identifier.id, label: identifier.label }];
};

export const removeEmpty = (object: any): any => {
  if (object === "" || object === null) return undefined;

  if (Array.isArray(object)) {
    object = object.filter((value: any) => {
      return value !== undefined || value !== "" || value !== null;
    });

    if (!object.length) object = undefined;
  }

  return object;
};
